import { axiosInstance } from "./rest";

export function createFreshdeskTicket(ticketDTO) {
  return axiosInstance.post('/api/v2/cloudCredits/supportTickets', ticketDTO);
}
